import _ from 'lodash';

export enum Feature {
  PLATFORM_FEATURE_CLOUD = 0x0e01, // 3585
  PLATFORM_FEATURE_ON_PREMISE = 0x0e02, // 3586
  PLATFORM_FEATURE_MUTUAL_AUTH_ENABLED = 0x0d01, // 3329
  PLATFORM_FEATURE_MUTUAL_AUTH_ENFORCED = 0x0d02, // 3330
  PLATFORM_FEATURE_XDR_SENSORS_O365 = 3073, // 0x0C01
  PLATFORM_FEATURE_XDR_SENSORS_AD_ONPREM = 3074,
  PLATFORM_FEATURE_XDR_SENSORS_AWS = 3075,
  PLATFORM_FEATURE_XDR_SENSORS_AZURE_AD = 3076,
  PLATFORM_FEATURE_XDR_SENSORS_NSVA = 3077,
  PLATFORM_FEATURE_XDR_SENSORS_INTUNE = 3078,
  PLATFORM_FEATURE_XDR_SENSORS_AZURE_CW = 3079,
  PLATFORM_FEATURE_XDR_SENSORS_GOOGLE_WORKSPACE = 3080,
  PLATFORM_FEATURE_XDR_SENSORS_GCP = 3081,
  PLATFORM_FEATURE_XDR_SENSORS_MOBILE_SECURITY = 3082,
  PLATFORM_FEATURE_XDR_SENSORS_CLOUD_SECURITY = 3083,
  PLATFORM_FEATURE_XDR_SENSORS_ATLASSIAN_CLOUD = 3093,
  PLATFORM_FEATURE_EDR_AUTOMATIC_ACTIONS = 3085,
  PLATFORM_FEATURE_EDR_AUTOMATIC_ACTION_ISOLATE = 3086,
  PLATFORM_FEATURE_EDR_AUTOMATIC_ACTION_COLLECT_INVESTIGATION_PACKAGE = 3087,
  PLATFORM_FEATURE_EDR_AUTOMATIC_ACTION_ADD_TO_SANDBOX = 3088,
  PLATFORM_FEATURE_EDR_AUTOMATIC_ACTION_KILL_PROCESS = 3089,
  PLATFORM_FEATURE_EDR_AUTOMATIC_ACTION_SCAN = 3090,
  PLATFORM_FEATURE_EDR_AUTOMATIC_ACTION_QUARANTINE = 3091,
  PLATFORM_FEATURE_EDR_AUTOMATIC_ACTION_RISK_SCAN = 3092,

  PRODUCT_FEATURE_HAS_DETECTED_THREATS = 0x0f2110,
  PRODUCT_FEATURE_HAS_ENDPOINT_INCIDENTS = 0x0f2111,

  PRODUCT_FEATURE_EPS_SERVICE = 0x0f0101, // 983297
  PRODUCT_FEATURE_SVE_SERVICE = 0x0f0201, // 983553
  PRODUCT_FEATURE_MDM_SERVICE = 0x0f0301, // 983809
  PRODUCT_FEATURE_EXCHANGE = 0x0f0401, // 984065
  PRODUCT_FEATURE_EXCHANGE_INSTALL = 0x0f0402, // 984066
  PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING = 0x0f0501, // 984321
  PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL = 0x0f0502, // 984322
  PRODUCT_FEATURE_REMOTE_ENGINES_SHARING = 0x0f0503, // 984323
  PRODUCT_FEATURE_ENDPOINTS_SERVICE = 0x0f0601, // 984577
  PRODUCT_FEATURE_AMAZON_EC2_REPORT_PAYMENT_STATUS = 0x0f0703, // 984835
  PRODUCT_FEATURE_AMAZON_EC2_REPORT_SUBSCRIPTION_STATUS = 0x0f0704, // 984836
  PRODUCT_FEATURE_AMAZON_EC2_CLOUD_INTEGRATION_CONFIGURED = 0x0f0707, // 984839
  PRODUCT_FEATURE_STAGING = 0x0f0b01,
  PRODUCT_FEATURE_RING_STAGING_VISIBLE = 0x0f0b02,
  PRODUCT_FEATURE_RING_STAGING_USABLE = 0x0f0b03,
  PRODUCT_FEATURE_ADVANCED_REPORTS = 0x0f0901,
  PRODUCT_FEATURE_CHANGE_DEFAULT_POLICY_ENDPOINTS = 0x0f0c01,
  PRODUCT_FEATURE_CHANGE_DEFAULT_POLICY_MDM = 0x0f0c02,
  PRODUCT_FEATURE_APPLICATION_CONTROL = 0x0f0c03,
  PRODUCT_FEATURE_VOLUME_ENCRYPTION_VISIBLE = 0x0f0d01,
  PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE = 0x0f0d02,
  PRODUCT_FEATURE_EASM_VISIBLE = 994120,
  PRODUCT_FEATURE_EASM_USABLE = 994121,
  PRODUCT_FEATURE_EASM_DELEGATE = 994122,
  PRODUCT_FEATURE_PHASR_USABLE = 994108,
  PRODUCT_FEATURE_PHASR_VISIBLE = 994109,
  PRODUCT_FEATURE_PHASR_DELEGATE = 994111,
  PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_VISIBLE = 0x0f0f00,
  PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE = 0x0f0f01,
  PRODUCT_FEATURE_SANDBOX_ANALYZER_VISIBLE = 0x0f1000,
  PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE = 0x0f1001,
  PRODUCT_FEATURE_SANDBOX_LOCAL_VISIBLE = 0x0f3010,
  PRODUCT_FEATURE_SANDBOX_LOCAL_USABLE = 0x0f3011,
  PRODUCT_FEATURE_SANDBOX_REPORTS = 0x0f3014,
  PRODUCT_FEATURE_GHOSTR_VISIBLE = 0x0f3012,
  PRODUCT_FEATURE_GHOSTR_USABLE = 0x0f3013,
  PRODUCT_FEATURE_FRAT_VISIBLE = 0x0f3300,
  PRODUCT_FEATURE_FRAT_USABLE = 0x0f3301,
  PRODUCT_FEATURE_FRAT_MANAGER = 0x0f3302,
  PRODUCT_FEATURE_RANSOMWARE_REMEDIATION_VISIBLE = 0x0f3400,
  PRODUCT_FEATURE_RANSOMWARE_REMEDIATION_USABLE = 0x0f3401,
  PRODUCT_FEATURE_PATCH_MANAGEMENT_VISIBLE = 0x0f1a01,
  PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE = 0x0f1a02,
  PRODUCT_FEATURE_STORAGE_PROTECTION_VISIBLE = 0x0f3000,
  PRODUCT_FEATURE_STORAGE_PROTECTION_USABLE = 0x0f3001,
  PRODUCT_FEATURE_AD_CLOUD_CONFIGURED = 0x0f1101,
  PRODUCT_FEATURE_EDR_VISIBLE = 0x0f2000,
  PRODUCT_FEATURE_EDR_USABLE = 0x0f2001,
  PRODUCT_FEATURE_EDR_INCIDENTS = 0x0f2002,
  PRODUCT_FEATURE_EDR_DEFAULT_PORTLETS = 0x0f2003,
  PRODUCT_FEATURE_ELITE_VISIBLE = 0x0f2004,
  PRODUCT_FEATURE_ELITE_USABLE = 0x0f2005,
  PRODUCT_FEATURE_ELITE_INCIDENTS = 0x0f2006,
  PRODUCT_FEATURE_ANY_EDR_VISIBLE = 0x0f2007,
  PRODUCT_FEATURE_ANY_EDR_USABLE = 0x0f2008,
  PRODUCT_FEATURE_ANY_EDR_INCIDENTS = 0x0f2009,
  PRODUCT_FEATURE_EDR_HISTORICAL_SEARCH = 0x0f2010,
  PRODUCT_FEATURE_EDR_BLOCKLIST = 0x0f2011,
  PRODUCT_FEATURE_EDR_PORTLETS = 0x0f2012,
  PRODUCT_FEATURE_EDR_CUSTOM_RULES = 0x0f2013,
  PRODUCT_FEATURE_XDR_VISIBLE = 0x0f2100,
  PRODUCT_FEATURE_XDR_USABLE = 0x0f2101,
  PRODUCT_FEATURE_XDR_INCIDENTS = 0x0f2102,
  PRODUCT_FEATURE_EDR_EXTENDED_VISIBLE = 0x0f2120,
  PRODUCT_FEATURE_EDR_EXTENDED_USABLE = 0x0f2121,
  PRODUCT_FEATURE_EDR_EXTENDED_INCIDENTS = 0x0f2122,
  PRODUCT_FEATURE_CLOUD = 0x0f1401,
  PRODUCT_FEATURE_NOT_CLOUD = 0x0f1402,
  PRODUCT_FEATURE_PARTNER_COMPANY = 0x0f1403,
  PRODUCT_FEATURE_MUTUAL_AUTH = 0x0f7000,
  PRODUCT_FEATURE_MUTUAL_AUTH_ENFORCED = 0x0f7002,
  PRODUCT_FEATURE_UPDATE_AD_SECURITY_GROUPS_USER_RULES = 0x0f2200,
  PRODUCT_FEATURE_READ_CREATE_AD_SECURITY_GROUPS_USER_RULES = 0x0f2201,
  PRODUCT_FEATURE_BUNDLE_LICENSE_GZ = 0x0f2202, // 991746
  PRODUCT_FEATURE_EVENTS_PUSH_SERVICE = 0x0f2401,
  PRODUCT_FEATURE_TERMINAL_VISIBLE = 0x0f2300,
  PRODUCT_FEATURE_TERMINAL_USABLE = 0x0f2301,
  PRODUCT_FEATURE_NSX_INTEGRATED = 0x0f2500,
  PRODUCT_FEATURE_NSX_CONFIGURED = 0x0f2501,
  PRODUCT_FEATURE_EMAIL_SECURITY_VISIBLE = 0x0f2a00,
  PRODUCT_FEATURE_EMAIL_SECURITY_USABLE = 0x0f2a01,
  PRODUCT_FEATURE_MOBILE_SECURITY_VISIBLE = 994048, // 0x0F2B00
  PRODUCT_FEATURE_MOBILE_SECURITY_USABLE = 994049, // 0x0F2B01
  PRODUCT_FEATURE_CWS_VISIBLE = 994100, // 0xF2B34
  PRODUCT_FEATURE_CWS_USABLE = 994101, // 0xF2B35
  PRODUCT_FEATURE_CWS_USABLE_DELEGATE = 999704, // 0x0f4118
  PRODUCT_FEATURE_CWS_STANDALONE = 994104, // 0x0F2B38
  PRODUCT_FEATURE_NTSA_VISIBLE = 0x0f0801,
  PRODUCT_FEATURE_NTSA_USABLE = 0x0f0802,
  PRODUCT_FEATURE_DASHBOARD_VISIBLE = 0x0f2600,
  PRODUCT_FEATURE_IOR_VISIBLE = 0x0f2700,
  PRODUCT_FEATURE_IOR_USABLE = 0x0f2701,
  PRODUCT_FEATURE_IOR_DATA = 0x0f2702,
  PRODUCT_FEATURE_BPP_USABLE = 0x0f2704,
  PRODUCT_FEATURE_COMPLIANCE_PREMIUM_DELEGATE = 0x0f2705,
  PRODUCT_FEATURE_COMPLIANCE_PREMIUM_USABLE = 0x0f2706,
  PRODUCT_FEATURE_BCST_IMAGE_SCANNER_USABLE = 0x0f2720,
  PRODUCT_FEATURE_CONTAINER_RUNTIME_USABLE = 0x0f2721,
  PRODUCT_FEATURE_KSPM_USABLE = 0x0f2722,
  PRODUCT_FEATURE_EXPLOIT_MITIGATION_VISIBLE = 0x0f2800,
  PRODUCT_FEATURE_EXPLOIT_MITIGATION_USABLE = 0x0f2801,
  PRODUCT_FEATURE_FILELESS_ATTACK_VISIBLE = 0x0f2900,
  PRODUCT_FEATURE_FILELESS_ATTACK_USABLE = 0x0f2901,
  PRODUCT_FEATURE_NETWORK_MONITOR_VISIBLE = 0x0f3800,
  PRODUCT_FEATURE_NETWORK_MONITOR_USABLE = 0x0f3801,
  PRODUCT_FEATURE_CONTENT_CONTROL_VISIBLE = 0x0f5100,
  PRODUCT_FEATURE_CONTENT_CONTROL_USABLE = 0x0f5101,
  PRODUCT_FEATURE_CUSTOM_FIELDS_VISIBLE = 0x0f3100,
  PRODUCT_FEATURE_ANTIMALWARE_OPTIONAL_USABLE = 0x0f3200,
  PRODUCT_FEATURE_EDR_ES_30DAYS_STORAGE = 0x0f3500,
  PRODUCT_FEATURE_EDR_ES_90DAYS_STORAGE = 0x0f3501,
  PRODUCT_FEATURE_EDR_ES_180DAYS_STORAGE = 0x0f3502,
  PRODUCT_FEATURE_EDR_ES_365DAYS_STORAGE = 0x0f3503,
  PRODUCT_FEATURE_BASIC_SECURITY_PROVIDER = 0x0f3900,
  PRODUCT_FEATURE_FIREWALL_VISIBLE = 0x0f3a00,
  PRODUCT_FEATURE_FIREWALL_USABLE = 0x0f3a01,
  PRODUCT_FEATURE_DEVICE_CONTROL_VISIBLE = 0x0f3b00,
  PRODUCT_FEATURE_DEVICE_CONTROL_USABLE = 0x0f3b01,
  PRODUCT_FEATURE_SECURITY_TELEMETRY_USABLE = 998400, // 0x0F3C00
  PRODUCT_FEATURE_SECURITY_TELEMETRY_VISIBLE = 998401, // 0x0F3C01
  PRODUCT_FEATURE_COMPANION_STANDALONE = 0x0f3700,
  PRODUCT_FEATURE_COMPANION_USABLE = 0x0f3701,
  PRODUCT_FEATURE_COMPANION_VISIBLE = 0x0f3702,
  PRODUCT_FEATURE_DEFAULT_PRODUCT_DELEGATE = 0x0f4000,
  PRODUCT_FEATURE_COMPANION_PRODUCT_DELEGATE = 0x0f4001,
  PRODUCT_FEATURE_EXCHANGE_INSTALL_DELEGATE = 0x0f4100,
  PRODUCT_FEATURE_EMAIL_SECURITY_USABLE_DELEGATE = 0x0f4101,
  PRODUCT_FEATURE_MOBILE_SECURITY_USABLE_DELEGATE = 999688, // 0x0F4108
  PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE_DELEGATE = 0x0f4102,
  PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL_DELEGATE = 0x0f4103,
  PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE_DELEGATE = 0x0f4104,
  PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE_DELEGATE = 0x0f4105,
  PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE_DELEGATE = 0x0f4106,
  PRODUCT_FEATURE_EDR_USABLE_DELEGATE = 0x0f4107,
  PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE_DELEGATE = 999689, //0x0F4109
  PRODUCT_FEATURE_MDR_ADVICE_USABLE_DELEGATE = 0x0f410a, // 999690
  PRODUCT_FEATURE_IDENTITY_SENSORS_USABLE_DELEGATE = 999692, // 0x0f410c
  PRODUCT_FEATURE_PRODUCTIVITY_SENSORS_USABLE_DELEGATE = 999693, // 0x0f410d
  PRODUCT_FEATURE_CLOUD_SENSORS_USABLE_DELEGATE = 999694, // 0x0f410e
  PRODUCT_FEATURE_NETWORK_SENSORS_USABLE_DELEGATE = 999695, // 0x0f410f
  PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE_DELEGATE = 999696, // 0x0F4110
  PRODUCT_FEATURE_DASHBOARD_V2_VISIBLE = 0x0f3600,
  PRODUCT_FEATURE_DASHBOARD_V2_DATA_COLLECTION = 0x0f3601,
  PRODUCT_FEATURE_DASHBOARD_V2_USER_VISIBLE = 0x0f3602,
  PRODUCT_FEATURE_ALERTS_VISIBLE = 0x0f3603,
  PRODUCT_FEATURE_ALERTS_USER_VISIBLE = 0x0f3604,
  PRODUCT_FEATURE_CONTAINER_PROTECTION_VISIBLE = 999937, // 0x0F4201
  PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE = 999936, // 0x0F4200
  PRODUCT_FEATURE_MDR_ADVICE_VISIBLE = 0x0f4300, // 1000192
  PRODUCT_FEATURE_MDR_ADVICE_USABLE = 0x0f4301, // 1000193

  PRODUCT_FEATURE_EARLY_ACCESS_VISIBLE = 991492, //0x0F2104
  PRODUCT_FEATURE_EARLY_ACCESS_USABLE = 991493, // 0x0F2105

  PRODUCT_FEATURE_SENSORS_INTEGRATIONS_VISIBLE = 999940, // 0x0F4204
  PRODUCT_FEATURE_PRODUCTIVITY_SENSORS = 999942, // 0x0F4206
  PRODUCT_FEATURE_IDENTITY_SENSORS = 999943, // 0x0F4207
  PRODUCT_FEATURE_CLOUD_SENSORS = 999944, // 0x0F4208
  PRODUCT_FEATURE_NETWORK_SENSORS = 999945, // 0x0F4209

  PRODUCT_FEATURE_INTEGRITY_MONITOR_VISIBLE = 1000448, // 0x0F4400
  PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE = 1000449, // 0x0F4401
  PRODUCT_FEATURE_IM_ES_90DAYS_STORAGE = 1000960, // 0x0F4600
  PRODUCT_FEATURE_IM_ES_180DAYS_STORAGE = 1000961, // 0x0F4601
  PRODUCT_FEATURE_IM_ES_365DAYS_STORAGE = 1000962, // 0x0F4602

  PRODUCT_FEATURE_ISOLATION_VISIBLE = 1000201,
  PRODUCT_FEATURE_ISOLATION_USABLE = 1000202,

  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_USABLE = 1001301,
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_DELEGATE = 1001302,
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_PLUS_USABLE = 1001303,
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_PLUS_DELEGATE = 1001304,
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_EXTRA_USABLE = 1001305,
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_EXTRA_DELEGATE = 1001306,
  PRODUCT_FEATURE_A_LA_CARTE_USABLE = 1001307,
  PRODUCT_FEATURE_A_LA_CARTE_DELEGATE = 1001308,

  PRODUCT_FEATURE_YARA_DETECTION_RULES = 1000707, // 0x0F4503

  PRODUCT_FEATURE_TAGS_VISIBLE = 1001216, // 0x0F4700
  PRODUCT_FEATURE_TAGS_USABLE = 1001217, // 0x0F4701

  PRODUCT_FEATURE_POLICY_RULES_VISIBLE = 1001728, // // 0x0F4900
  PRODUCT_FEATURE_POLICY_RULES_USABLE = 1001729, // // 0x0F4901

  PRODUCT_FEATURE_API_USABLE = 1001472, //0x0F4800
  PRODUCT_FEATURE_COP = 1003520, //0x0F5000

  PRODUCT_FEATURE_REMOTE_ACCESS = 991491,

  PRODUCT_FEATURE_PREMIUM_VISIBLE = 1004032, // 0x0F5200
  PRODUCT_FEATURE_PREMIUM_USABLE = 1004033, // 0x0F5201

  PRODUCT_FEATURE_IN_PRODUCT_BUY = 1001219,
  PRODUCT_FEATURE_IN_PRODUCT_TRIALS = 1001218,

  PRODUCT_FEATURE_INVESTIGATION_TOOLS_VISIBLE = 999938,
  PRODUCT_FEATURE_INVESTIGATION_TOOLS_USABLE = 999939,

  PRODUCT_FEATURE_LIVE_SEARCH_VISIBLE = 1000706, //0x0F4502
  PRODUCT_FEATURE_LIVE_SEARCH_USABLE = 1000704,

  PRODUCT_FEATURE_VMWARE_SYNC_VISIBLE = 1004036, // 0x0F5204
  PRODUCT_FEATURE_VMWARE_SYNC_USABLE = 1004037, // 0x0F5205
}

export enum FeatureFlag {
  // on-premise only
  PRODUCT_FEATURE_GHOSTR_VISIBLE = 'ghostrVisible',
  PRODUCT_FEATURE_GHOSTR_USABLE = 'ghostrUsable',
  PRODUCT_FEATURE_NSX_INTEGRATED = 'nsxIntegrated',
  PRODUCT_FEATURE_NSX_CONFIGURED = 'nsxConfigured',
  PRODUCT_FEATURE_SANDBOX_LOCAL_VISIBLE = 'sandboxLocalVisible',
  PRODUCT_FEATURE_SANDBOX_LOCAL_USABLE = 'sandboxLocalUsable',
  PRODUCT_FEATURE_NTSA_USABLE = 'ntsaUsable',
  PRODUT_FEAT_FEACT_FEATURE_NTSA_VISIBLE = 'ntsaVisible',

  // cloud only
  PRODUCT_FEATURE_AMAZON_EC2_REPORT_PAYMENT_STATUS = 'awsPaymentStatusReport',
  PRODUCT_FEATURE_AMAZON_EC2_REPORT_SUBSCRIPTION_STATUS = 'awsSubscriptionStatusReport',
  PRODUCT_FEATURE_AD_CLOUD_CONFIGURED = 'adCloudConfigured',
  PRODUCT_FEATURE_DASHBOARD_VISIBLE = 'dashboardVisible',
  PRODUCT_FEATURE_IOR_VISIBLE = 'iorVisible',
  PRODUCT_FEATURE_IOR_USABLE = 'iorUsable',
  PRODUCT_FEATURE_BPP_USABLE = 'bppUsable',
  PRODUCT_FEATURE_BCST_IMAGE_SCANNER_USABLE = 'bcstImageScannerUsable',
  PRODUCT_FEATURE_CONTAINER_RUNTIME_USABLE = 'containerRuntimeUsable',
  PRODUCT_FEATURE_KSPM_USABLE = 'kspmUsable',
  PRODUCT_FEATURE_EMAIL_SECURITY_USABLE = 'emailSecurityUsable',
  PRODUCT_FEATURE_EMAIL_SECURITY_VISIBLE = 'emailSecurityVisible',
  PRODUCT_FEATURE_MOBILE_SECURITY_USABLE = 'mobileSecurityUsable',
  PRODUCT_FEATURE_MOBILE_SECURITY_VISIBLE = 'mobileSecurityVisible',
  PRODUCT_FEATURE_CWS_USABLE = 'cloudWorkloadSecurityUsable',
  PRODUCT_FEATURE_CWS_VISIBLE = 'cloudWorkloadSecurityVisible',
  PRODUCT_FEATURE_CWS_USABLE_DELEGATE = 'cloudWorkloadSecurityUsableDelegate',
  PRODUCT_FEATURE_CWS_STANDALONE = 'cloudWorkloadSecurityStandalone',
  PRODUCT_FEATURE_FRAT_VISIBLE = 'fratVisible',
  PRODUCT_FEATURE_FRAT_USABLE = 'fratUsable',
  PRODUCT_FEATURE_FRAT_MANAGER = 'fratManager',
  PRODUCT_FEATURE_DASHBOARD_V2_VISIBLE = 'dashboardV2Visible',
  PRODUCT_FEATURE_DASHBOARD_V2_DATA_COLLECTION = 'dashboardV2DataCollection',
  PRODUCT_FEATURE_BASIC_SECURITY_PROVIDER = 'basicSecurityProvider',
  PRODUCT_FEATURE_ALERTS_VISIBLE = 'alertsVisible',
  PRODUCT_FEATURE_MDR_ADVICE_VISIBLE = 'mdrAdviceVisible', // 1000192
  PRODUCT_FEATURE_MDR_ADVICE_USABLE = 'mdrAdviceUsable', // 1000193
  PRODUCT_FEATURE_MDR_ADVICE_USABLE_DELEGATE = 'mdrAdviceDelegate', // 999690
  PRODUCT_FEATURE_INTEGRITY_MONITOR_VISIBLE = 'integrityMonitorVisible', // 1000448
  PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE = 'integrityMonitorUsable', // 1000449
  PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE_DELEGATE = 'integrityMonitorUsableDelegate', // 999696
  PRODUCT_FEATURE_IM_ES_90DAYS_STORAGE = 'imES90daysStorage', // 1000960
  PRODUCT_FEATURE_IM_ES_180DAYS_STORAGE = 'imES180daysStorage', // 1000961
  PRODUCT_FEATURE_IM_ES_365DAYS_STORAGE = 'imES365daysStorage', // 1000962
  PRODUCT_FEATURE_EASM_USABLE = 'easmUsable',
  PRODUCT_FEATURE_EASM_VISIBLE = 'easmVisible',
  PRODUCT_FEATURE_EASM_DELEGATE = 'easmDelegate',
  PRODUCT_FEATURE_PHASR_USABLE = 'phasrUsable',
  PRODUCT_FEATURE_PHASR_VISIBLE = 'phasrVisible',
  PRODUCT_FEATURE_COMPLIANCE_PREMIUM_USABLE = 'compliancePremiumUsable',
  PRODUCT_FEATURE_PHASR_DELEGATE = 'phasrDelegate',
  PRODUCT_FEATURE_COMPLIANCE_PREMIUM_DELEGATE = 'compliancePremiumDelegate',

  // cloud and on-premise
  PRODUCT_FEATURE_EXCHANGE = 'exchangeVisible',
  PRODUCT_FEATURE_EXCHANGE_INSTALL = 'exchangeUsable',
  PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_VISIBLE = 'paranoidVisible',
  PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE = 'paranoidUsable',
  PRODUCT_FEATURE_SANDBOX_ANALYZER_VISIBLE = 'sandboxVisible',
  PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE = 'sandboxUsable',
  PRODUCT_FEATURE_VOLUME_ENCRYPTION_VISIBLE = 'encryptionVisible',
  PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE = 'encryptionUsable',
  PRODUCT_FEATURE_PATCH_MANAGEMENT_VISIBLE = 'patchManagementVisible',
  PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE = 'patchManagementUsable',
  PRODUCT_FEATURE_REMOTE_ENGINES_SHARING = 'remoteEnginesSharing',
  PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING = 'remoteEnginesScanningVisible',
  PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL = 'remoteEnginesScanningUsable',
  PRODUCT_FEATURE_STORAGE_PROTECTION_VISIBLE = 'storageProtectionVisible',
  PRODUCT_FEATURE_STORAGE_PROTECTION_USABLE = 'storageProtectionUsable',
  PRODUCT_FEATURE_AMAZON_EC2_CLOUD_INTEGRATION_CONFIGURED = 'awsEc2IntegrationConfigured',
  PRODUCT_FEATURE_TERMINAL_VISIBLE = 'terminalVisible',
  PRODUCT_FEATURE_TERMINAL_USABLE = 'terminalUsable',
  PRODUCT_FEATURE_EXPLOIT_MITIGATION_VISIBLE = 'exploitMitigationVisible',
  PRODUCT_FEATURE_EXPLOIT_MITIGATION_USABLE = 'exploitMitigationUsable',
  PRODUCT_FEATURE_FILELESS_ATTACK_USABLE = 'filelessAttackUsable',
  PRODUCT_FEATURE_FILELESS_ATTACK_VISIBLE = 'filelessAttackVisible',
  PRODUCT_FEATURE_EDR_VISIBLE = 'edrVisible',
  PRODUCT_FEATURE_EDR_USABLE = 'edrUsable',
  PRODUCT_FEATURE_ELITE_VISIBLE = 'eliteVisible',
  PRODUCT_FEATURE_ELITE_USABLE = 'eliteUsable',
  PRODUCT_FEATURE_XDR_VISIBLE = 'xdrVisible',
  PRODUCT_FEATURE_XDR_USABLE = 'xdrUsable',
  PRODUCT_FEATURE_NETWORK_MONITOR_VISIBLE = 'networkMonitorVisible',
  PRODUCT_FEATURE_NETWORK_MONITOR_USABLE = 'networkMonitorUsable',
  PRODUCT_FEATURE_CONTENT_CONTROL_VISIBLE = 'contentControlVisible',
  PRODUCT_FEATURE_CONTENT_CONTROL_USABLE = 'contentControlUsable',
  PRODUCT_FEATURE_CUSTOM_FIELDS_VISIBLE = 'customFieldsVisible',
  PRODUCT_FEATURE_ANTIMALWARE_OPTIONAL_USABLE = 'antimalwareOptionalUsable',
  PRODUCT_FEATURE_EDR_ES_30DAYS_STORAGE = 'edrES30daysStorage',
  PRODUCT_FEATURE_EDR_ES_90DAYS_STORAGE = 'edrES90daysStorage',
  PRODUCT_FEATURE_EDR_ES_180DAYS_STORAGE = 'edrES180daysStorage',
  PRODUCT_FEATURE_EDR_ES_365DAYS_STORAGE = 'edrES365daysStorage',
  PRODUCT_FEATURE_RANSOMWARE_REMEDIATION_VISIBLE = 'ransomwareRemediationVisible',
  PRODUCT_FEATURE_RANSOMWARE_REMEDIATION_USABLE = 'ransomwareRemediationUsable',
  PRODUCT_FEATURE_DEVICE_CONTROL_VISIBLE = 'deviceControlVisible',
  PRODUCT_FEATURE_DEVICE_CONTROL_USABLE = 'deviceControlUsable',
  PRODUCT_FEATURE_FIREWALL_VISIBLE = 'firewallVisible',
  PRODUCT_FEATURE_FIREWALL_USABLE = 'firewallUsable',
  PRODUCT_FEATURE_SECURITY_TELEMETRY_VISIBLE = 'securityTelemetryVisible',
  PRODUCT_FEATURE_SECURITY_TELEMETRY_USABLE = 'securityTelemetryUsable',
  PRODUCT_FEATURE_COMPANION_STANDALONE = 'companionStandalone',
  PRODUCT_FEATURE_COMPANION_USABLE = 'companionUsable',
  PRODUCT_FEATURE_COMPANION_VISIBLE = 'companionVisible',
  PRODUCT_FEATURE_DEFAULT_PRODUCT_DELEGATE = 'defaultProductDelegate',
  PRODUCT_FEATURE_COMPANION_PRODUCT_DELEGATE = 'companionProductDelegate',
  PRODUCT_FEATURE_EXCHANGE_INSTALL_DELEGATE = 'exchangeUsableDelegate',
  PRODUCT_FEATURE_EMAIL_SECURITY_USABLE_DELEGATE = 'emailSecurityUsableDelegate',
  PRODUCT_FEATURE_MOBILE_SECURITY_USABLE_DELEGATE = 'mobileSecurityUsableDelegate',
  PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE_DELEGATE = 'encryptionUsableDelegate',
  PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL_DELEGATE = 'remoteEnginesScanningUsableDelegate',
  PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE_DELEGATE = 'containerProtectionUsableDelegate',
  PRODUCT_FEATURE_IDENTITY_SENSORS_USABLE_DELEGATE = 'identitySensorsUsableDelegate',
  PRODUCT_FEATURE_PRODUCTIVITY_SENSORS_USABLE_DELEGATE = 'productivitySensorsUsableDelegate',
  PRODUCT_FEATURE_CLOUD_SENSORS_USABLE_DELEGATE = 'cloudSensorsUsableDelegate',
  PRODUCT_FEATURE_NETWORK_SENSORS_USABLE_DELEGATE = 'networkSensorsUsableDelegate',
  PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE_DELEGATE = 'patchManagementUsableDelegate',
  PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE_DELEGATE = 'paranoidUsableDelegate',
  PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE_DELEGATE = 'sandboxUsableDelegate',
  PRODUCT_FEATURE_EDR_USABLE_DELEGATE = 'edrUsableDelegate',
  PRODUCT_FEATURE_CONTAINER_PROTECTION_VISIBLE = 'containerProtectionVisible',
  PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE = 'containerProtectionUsable',
  PRODUCT_FEATURE_ISOLATION_VISIBLE = 'isolationVisible',
  PRODUCT_FEATURE_ISOLATION_USABLE = 'isolationUsable',
  PRODUCT_FEATURE_IDENTITY_SENSORS = 'identitySensors',
  PRODUCT_FEATURE_PRODUCTIVITY_SENSORS = 'productivitySensors',
  PRODUCT_FEATURE_CLOUD_SENSORS = 'cloudSensors',
  PRODUCT_FEATURE_NETWORK_SENSORS = 'networkSensors',
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_USABLE = 'bundleMspSecureUsable',
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_DELEGATE = 'bundleMspSecureDelegate',
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_PLUS_USABLE = 'bundleMspSecurePlusUsable',
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_PLUS_DELEGATE = 'bundleMspSecurePlusDelegate',
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_EXTRA_USABLE = 'bundleMspSecureExtraUsable',
  PRODUCT_FEATURE_BUNDLE_MSP_SECURE_EXTRA_DELEGATE = 'bundleMspSecureExtraDelegate',
  PRODUCT_FEATURE_A_LA_CARTE_USABLE = 'aLaCarteUsable',
  PRODUCT_FEATURE_A_LA_CARTE_DELEGATE = 'aLaCarteDelegate',
  PRODUCT_FEATURE_TAGS_VISIBLE = 'tagsVisible',
  PRODUCT_FEATURE_TAGS_USABLE = 'tagsUsable',
  PRODUCT_FEATURE_POLICY_RULES_VISIBLE = 'policyRulesVisible',
  PRODUCT_FEATURE_POLICY_RULES_USABLE = 'policyRulesUsable',
  PRODUCT_FEATURE_API_USABLE = 'apiUsable',
  PRODUCT_FEATURE_COP = 'cop',
  PRODUCT_FEATURE_PREMIUM_VISIBLE = 'premiumVisible',
  PRODUCT_FEATURE_PREMIUM_USABLE = 'premiumUsable',
  PRODUCT_FEATURE_MSP_IN_PRODUCT_TRIAL_EDR_VISIBLE = 'edrMspInProductTrialVisible',
  PRODUCT_FEATURE_MSP_IN_PRODUCT_TRIAL_EDR_DELEGATE = 'edrMspInProductTrialDelegate',
  PRODUCT_FEATURE_MSP_IN_PRODUCT_TRIAL_MDR_VISIBLE = 'mdrMspInProductTrialVisible',
  PRODUCT_FEATURE_MSP_IN_PRODUCT_TRIAL_MDR_DELEGATE = 'mdrMspInProductTrialDelegate',
  PRODUCT_FEATURE_IN_PRODUCT_BUY = 'inProductBuy',
  PRODUCT_FEATURE_RING_STAGING_VISIBLE = 'ringStagingVisible',
  PRODUCT_FEATURE_RING_STAGING_USABLE = 'ringStagingUsable',
  PRODUCT_FEATURE_VMWARE_SYNC_VISIBLE = 'vmwareSyncVisible',
  PRODUCT_FEATURE_VMWARE_SYNC_USABLE = 'vmwareSyncUsable',
}

export const FeatureIdToUsableMapping: { [featureId: number]: FeatureFlag } = {
  [Feature.PRODUCT_FEATURE_EXCHANGE]: FeatureFlag.PRODUCT_FEATURE_EXCHANGE,
  [Feature.PRODUCT_FEATURE_EXCHANGE_INSTALL]: FeatureFlag.PRODUCT_FEATURE_EXCHANGE_INSTALL,
  [Feature.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING]: FeatureFlag.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING,
  [Feature.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL]:
    FeatureFlag.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL,
  [Feature.PRODUCT_FEATURE_REMOTE_ENGINES_SHARING]: FeatureFlag.PRODUCT_FEATURE_REMOTE_ENGINES_SHARING,
  [Feature.PRODUCT_FEATURE_AMAZON_EC2_REPORT_PAYMENT_STATUS]:
    FeatureFlag.PRODUCT_FEATURE_AMAZON_EC2_REPORT_PAYMENT_STATUS,
  [Feature.PRODUCT_FEATURE_AMAZON_EC2_REPORT_SUBSCRIPTION_STATUS]:
    FeatureFlag.PRODUCT_FEATURE_AMAZON_EC2_REPORT_SUBSCRIPTION_STATUS,
  [Feature.PRODUCT_FEATURE_AMAZON_EC2_CLOUD_INTEGRATION_CONFIGURED]:
    FeatureFlag.PRODUCT_FEATURE_AMAZON_EC2_CLOUD_INTEGRATION_CONFIGURED,
  [Feature.PRODUCT_FEATURE_VOLUME_ENCRYPTION_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_VOLUME_ENCRYPTION_VISIBLE,
  [Feature.PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE]: FeatureFlag.PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE,
  [Feature.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_VISIBLE]:
    FeatureFlag.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_VISIBLE,
  [Feature.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE]:
    FeatureFlag.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE,
  [Feature.PRODUCT_FEATURE_SANDBOX_ANALYZER_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_SANDBOX_ANALYZER_VISIBLE,
  [Feature.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE]: FeatureFlag.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE,
  [Feature.PRODUCT_FEATURE_SANDBOX_LOCAL_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_SANDBOX_LOCAL_VISIBLE,
  [Feature.PRODUCT_FEATURE_SANDBOX_LOCAL_USABLE]: FeatureFlag.PRODUCT_FEATURE_SANDBOX_LOCAL_USABLE,
  [Feature.PRODUCT_FEATURE_GHOSTR_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_GHOSTR_VISIBLE,
  [Feature.PRODUCT_FEATURE_GHOSTR_USABLE]: FeatureFlag.PRODUCT_FEATURE_GHOSTR_USABLE,
  [Feature.PRODUCT_FEATURE_FRAT_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_FRAT_VISIBLE,
  [Feature.PRODUCT_FEATURE_FRAT_USABLE]: FeatureFlag.PRODUCT_FEATURE_FRAT_USABLE,
  [Feature.PRODUCT_FEATURE_FRAT_MANAGER]: FeatureFlag.PRODUCT_FEATURE_FRAT_MANAGER,
  [Feature.PRODUCT_FEATURE_RANSOMWARE_REMEDIATION_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_RANSOMWARE_REMEDIATION_VISIBLE,
  [Feature.PRODUCT_FEATURE_RANSOMWARE_REMEDIATION_USABLE]: FeatureFlag.PRODUCT_FEATURE_RANSOMWARE_REMEDIATION_USABLE,
  [Feature.PRODUCT_FEATURE_PATCH_MANAGEMENT_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_PATCH_MANAGEMENT_VISIBLE,
  [Feature.PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE]: FeatureFlag.PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE,
  [Feature.PRODUCT_FEATURE_STORAGE_PROTECTION_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_STORAGE_PROTECTION_VISIBLE,
  [Feature.PRODUCT_FEATURE_STORAGE_PROTECTION_USABLE]: FeatureFlag.PRODUCT_FEATURE_STORAGE_PROTECTION_USABLE,
  [Feature.PRODUCT_FEATURE_AD_CLOUD_CONFIGURED]: FeatureFlag.PRODUCT_FEATURE_AD_CLOUD_CONFIGURED,
  [Feature.PRODUCT_FEATURE_EDR_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_EDR_VISIBLE,
  [Feature.PRODUCT_FEATURE_EDR_USABLE]: FeatureFlag.PRODUCT_FEATURE_EDR_USABLE,
  [Feature.PRODUCT_FEATURE_ELITE_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_ELITE_VISIBLE,
  [Feature.PRODUCT_FEATURE_ELITE_USABLE]: FeatureFlag.PRODUCT_FEATURE_ELITE_USABLE,
  [Feature.PRODUCT_FEATURE_XDR_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_XDR_VISIBLE,
  [Feature.PRODUCT_FEATURE_XDR_USABLE]: FeatureFlag.PRODUCT_FEATURE_XDR_USABLE,
  [Feature.PRODUCT_FEATURE_TERMINAL_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_TERMINAL_VISIBLE,
  [Feature.PRODUCT_FEATURE_TERMINAL_USABLE]: FeatureFlag.PRODUCT_FEATURE_TERMINAL_USABLE,
  [Feature.PRODUCT_FEATURE_NSX_INTEGRATED]: FeatureFlag.PRODUCT_FEATURE_NSX_INTEGRATED,
  [Feature.PRODUCT_FEATURE_NSX_CONFIGURED]: FeatureFlag.PRODUCT_FEATURE_NSX_CONFIGURED,
  [Feature.PRODUCT_FEATURE_EMAIL_SECURITY_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_EMAIL_SECURITY_VISIBLE,
  [Feature.PRODUCT_FEATURE_EMAIL_SECURITY_USABLE]: FeatureFlag.PRODUCT_FEATURE_EMAIL_SECURITY_USABLE,
  [Feature.PRODUCT_FEATURE_MOBILE_SECURITY_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_MOBILE_SECURITY_VISIBLE,
  [Feature.PRODUCT_FEATURE_MOBILE_SECURITY_USABLE]: FeatureFlag.PRODUCT_FEATURE_MOBILE_SECURITY_USABLE,
  [Feature.PRODUCT_FEATURE_CWS_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_CWS_VISIBLE,
  [Feature.PRODUCT_FEATURE_CWS_USABLE]: FeatureFlag.PRODUCT_FEATURE_CWS_USABLE,
  [Feature.PRODUCT_FEATURE_CWS_USABLE_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_CWS_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_CWS_STANDALONE]: FeatureFlag.PRODUCT_FEATURE_CWS_STANDALONE,
  [Feature.PRODUCT_FEATURE_NTSA_USABLE]: FeatureFlag.PRODUCT_FEATURE_NTSA_USABLE,
  [Feature.PRODUCT_FEATURE_DASHBOARD_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_DASHBOARD_VISIBLE,
  [Feature.PRODUCT_FEATURE_IOR_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_IOR_VISIBLE,
  [Feature.PRODUCT_FEATURE_IOR_USABLE]: FeatureFlag.PRODUCT_FEATURE_IOR_USABLE,
  [Feature.PRODUCT_FEATURE_BPP_USABLE]: FeatureFlag.PRODUCT_FEATURE_BPP_USABLE,
  [Feature.PRODUCT_FEATURE_BCST_IMAGE_SCANNER_USABLE]: FeatureFlag.PRODUCT_FEATURE_BCST_IMAGE_SCANNER_USABLE,
  [Feature.PRODUCT_FEATURE_CONTAINER_RUNTIME_USABLE]: FeatureFlag.PRODUCT_FEATURE_CONTAINER_RUNTIME_USABLE,
  [Feature.PRODUCT_FEATURE_KSPM_USABLE]: FeatureFlag.PRODUCT_FEATURE_KSPM_USABLE,
  [Feature.PRODUCT_FEATURE_EXPLOIT_MITIGATION_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_EXPLOIT_MITIGATION_VISIBLE,
  [Feature.PRODUCT_FEATURE_EXPLOIT_MITIGATION_USABLE]: FeatureFlag.PRODUCT_FEATURE_EXPLOIT_MITIGATION_USABLE,
  [Feature.PRODUCT_FEATURE_FILELESS_ATTACK_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_FILELESS_ATTACK_VISIBLE,
  [Feature.PRODUCT_FEATURE_FILELESS_ATTACK_USABLE]: FeatureFlag.PRODUCT_FEATURE_FILELESS_ATTACK_USABLE,
  [Feature.PRODUCT_FEATURE_NETWORK_MONITOR_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_NETWORK_MONITOR_VISIBLE,
  [Feature.PRODUCT_FEATURE_NETWORK_MONITOR_USABLE]: FeatureFlag.PRODUCT_FEATURE_NETWORK_MONITOR_USABLE,
  [Feature.PRODUCT_FEATURE_CONTENT_CONTROL_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_CONTENT_CONTROL_VISIBLE,
  [Feature.PRODUCT_FEATURE_CONTENT_CONTROL_USABLE]: FeatureFlag.PRODUCT_FEATURE_CONTENT_CONTROL_USABLE,
  [Feature.PRODUCT_FEATURE_CUSTOM_FIELDS_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_CUSTOM_FIELDS_VISIBLE,
  [Feature.PRODUCT_FEATURE_ANTIMALWARE_OPTIONAL_USABLE]: FeatureFlag.PRODUCT_FEATURE_ANTIMALWARE_OPTIONAL_USABLE,
  [Feature.PRODUCT_FEATURE_EDR_ES_30DAYS_STORAGE]: FeatureFlag.PRODUCT_FEATURE_EDR_ES_30DAYS_STORAGE,
  [Feature.PRODUCT_FEATURE_EDR_ES_90DAYS_STORAGE]: FeatureFlag.PRODUCT_FEATURE_EDR_ES_90DAYS_STORAGE,
  [Feature.PRODUCT_FEATURE_EDR_ES_180DAYS_STORAGE]: FeatureFlag.PRODUCT_FEATURE_EDR_ES_180DAYS_STORAGE,
  [Feature.PRODUCT_FEATURE_EDR_ES_365DAYS_STORAGE]: FeatureFlag.PRODUCT_FEATURE_EDR_ES_365DAYS_STORAGE,
  [Feature.PRODUCT_FEATURE_BASIC_SECURITY_PROVIDER]: FeatureFlag.PRODUCT_FEATURE_BASIC_SECURITY_PROVIDER,
  [Feature.PRODUCT_FEATURE_FIREWALL_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_FIREWALL_VISIBLE,
  [Feature.PRODUCT_FEATURE_FIREWALL_USABLE]: FeatureFlag.PRODUCT_FEATURE_FIREWALL_USABLE,
  [Feature.PRODUCT_FEATURE_DEVICE_CONTROL_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_DEVICE_CONTROL_VISIBLE,
  [Feature.PRODUCT_FEATURE_DEVICE_CONTROL_USABLE]: FeatureFlag.PRODUCT_FEATURE_DEVICE_CONTROL_USABLE,
  [Feature.PRODUCT_FEATURE_SECURITY_TELEMETRY_USABLE]: FeatureFlag.PRODUCT_FEATURE_SECURITY_TELEMETRY_USABLE,
  [Feature.PRODUCT_FEATURE_SECURITY_TELEMETRY_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_SECURITY_TELEMETRY_VISIBLE,
  [Feature.PRODUCT_FEATURE_COMPANION_STANDALONE]: FeatureFlag.PRODUCT_FEATURE_COMPANION_STANDALONE,
  [Feature.PRODUCT_FEATURE_COMPANION_USABLE]: FeatureFlag.PRODUCT_FEATURE_COMPANION_USABLE,
  [Feature.PRODUCT_FEATURE_COMPANION_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_COMPANION_VISIBLE,
  [Feature.PRODUCT_FEATURE_DEFAULT_PRODUCT_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_DEFAULT_PRODUCT_DELEGATE,
  [Feature.PRODUCT_FEATURE_COMPANION_PRODUCT_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_COMPANION_PRODUCT_DELEGATE,
  [Feature.PRODUCT_FEATURE_EXCHANGE_INSTALL_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_EXCHANGE_INSTALL_DELEGATE,
  [Feature.PRODUCT_FEATURE_EMAIL_SECURITY_USABLE_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_EMAIL_SECURITY_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_MOBILE_SECURITY_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_MOBILE_SECURITY_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL_DELEGATE,
  [Feature.PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_EDR_USABLE_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_EDR_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_MDR_ADVICE_USABLE_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_MDR_ADVICE_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_DASHBOARD_V2_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_DASHBOARD_V2_VISIBLE,
  [Feature.PRODUCT_FEATURE_DASHBOARD_V2_DATA_COLLECTION]: FeatureFlag.PRODUCT_FEATURE_DASHBOARD_V2_DATA_COLLECTION,
  [Feature.PRODUCT_FEATURE_ALERTS_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_ALERTS_VISIBLE,
  [Feature.PRODUCT_FEATURE_CONTAINER_PROTECTION_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_CONTAINER_PROTECTION_VISIBLE,
  [Feature.PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE]: FeatureFlag.PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE,
  [Feature.PRODUCT_FEATURE_MDR_ADVICE_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_MDR_ADVICE_VISIBLE,
  [Feature.PRODUCT_FEATURE_MDR_ADVICE_USABLE]: FeatureFlag.PRODUCT_FEATURE_MDR_ADVICE_USABLE,
  [Feature.PRODUCT_FEATURE_IDENTITY_SENSORS_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_IDENTITY_SENSORS_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_IDENTITY_SENSORS]: FeatureFlag.PRODUCT_FEATURE_IDENTITY_SENSORS,
  [Feature.PRODUCT_FEATURE_PRODUCTIVITY_SENSORS_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_PRODUCTIVITY_SENSORS_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_PRODUCTIVITY_SENSORS]: FeatureFlag.PRODUCT_FEATURE_PRODUCTIVITY_SENSORS,
  [Feature.PRODUCT_FEATURE_CLOUD_SENSORS_USABLE_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_CLOUD_SENSORS_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_CLOUD_SENSORS]: FeatureFlag.PRODUCT_FEATURE_CLOUD_SENSORS,
  [Feature.PRODUCT_FEATURE_NETWORK_SENSORS_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_NETWORK_SENSORS_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_NETWORK_SENSORS]: FeatureFlag.PRODUCT_FEATURE_NETWORK_SENSORS,
  [Feature.PRODUCT_FEATURE_ISOLATION_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_ISOLATION_VISIBLE,
  [Feature.PRODUCT_FEATURE_ISOLATION_USABLE]: FeatureFlag.PRODUCT_FEATURE_ISOLATION_USABLE,
  [Feature.PRODUCT_FEATURE_INTEGRITY_MONITOR_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_INTEGRITY_MONITOR_VISIBLE,
  [Feature.PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE]: FeatureFlag.PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE,
  [Feature.PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE_DELEGATE]:
    FeatureFlag.PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE_DELEGATE,
  [Feature.PRODUCT_FEATURE_TAGS_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_TAGS_VISIBLE,
  [Feature.PRODUCT_FEATURE_TAGS_USABLE]: FeatureFlag.PRODUCT_FEATURE_TAGS_USABLE,
  [Feature.PRODUCT_FEATURE_POLICY_RULES_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_POLICY_RULES_VISIBLE,
  [Feature.PRODUCT_FEATURE_POLICY_RULES_USABLE]: FeatureFlag.PRODUCT_FEATURE_POLICY_RULES_USABLE,
  [Feature.PRODUCT_FEATURE_API_USABLE]: FeatureFlag.PRODUCT_FEATURE_API_USABLE,
  [Feature.PRODUCT_FEATURE_COP]: FeatureFlag.PRODUCT_FEATURE_COP,
  [Feature.PRODUCT_FEATURE_PREMIUM_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_PREMIUM_VISIBLE,
  [Feature.PRODUCT_FEATURE_PREMIUM_USABLE]: FeatureFlag.PRODUCT_FEATURE_PREMIUM_USABLE,
  [Feature.PRODUCT_FEATURE_EASM_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_EASM_VISIBLE,
  [Feature.PRODUCT_FEATURE_EASM_USABLE]: FeatureFlag.PRODUCT_FEATURE_EASM_USABLE,
  [Feature.PRODUCT_FEATURE_EASM_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_EASM_DELEGATE,
  [Feature.PRODUCT_FEATURE_PHASR_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_PHASR_VISIBLE,
  [Feature.PRODUCT_FEATURE_PHASR_USABLE]: FeatureFlag.PRODUCT_FEATURE_PHASR_USABLE,
  [Feature.PRODUCT_FEATURE_PHASR_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_PHASR_DELEGATE,
  [Feature.PRODUCT_FEATURE_IN_PRODUCT_BUY]: FeatureFlag.PRODUCT_FEATURE_IN_PRODUCT_BUY,
  [Feature.PRODUCT_FEATURE_VMWARE_SYNC_VISIBLE]: FeatureFlag.PRODUCT_FEATURE_VMWARE_SYNC_VISIBLE,
  [Feature.PRODUCT_FEATURE_VMWARE_SYNC_USABLE]: FeatureFlag.PRODUCT_FEATURE_VMWARE_SYNC_USABLE,
  [Feature.PRODUCT_FEATURE_COMPLIANCE_PREMIUM_USABLE]: FeatureFlag.PRODUCT_FEATURE_COMPLIANCE_PREMIUM_USABLE,
  [Feature.PRODUCT_FEATURE_COMPLIANCE_PREMIUM_DELEGATE]: FeatureFlag.PRODUCT_FEATURE_COMPLIANCE_PREMIUM_DELEGATE,
};

export const FeatureIdDelegateToIdUsableMapping: { [featureId: number]: Feature } = {
  [Feature.PRODUCT_FEATURE_EXCHANGE_INSTALL_DELEGATE]: Feature.PRODUCT_FEATURE_EXCHANGE_INSTALL,
  [Feature.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL_DELEGATE]:
    Feature.PRODUCT_FEATURE_REMOTE_ENGINES_SCANNING_INSTALL,
  [Feature.PRODUCT_FEATURE_EMAIL_SECURITY_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_EMAIL_SECURITY_USABLE,
  [Feature.PRODUCT_FEATURE_MOBILE_SECURITY_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_MOBILE_SECURITY_USABLE,
  [Feature.PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_VOLUME_ENCRYPTION_USABLE,
  [Feature.PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_PATCH_MANAGEMENT_USABLE,
  [Feature.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE_DELEGATE]:
    Feature.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE,
  [Feature.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE,
  [Feature.PRODUCT_FEATURE_EDR_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_EDR_USABLE,
  [Feature.PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_CONTAINER_PROTECTION_USABLE,
  [Feature.PRODUCT_FEATURE_MDR_ADVICE_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_MDR_ADVICE_USABLE,
  [Feature.PRODUCT_FEATURE_IDENTITY_SENSORS_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_IDENTITY_SENSORS,
  [Feature.PRODUCT_FEATURE_PRODUCTIVITY_SENSORS_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_PRODUCTIVITY_SENSORS,
  [Feature.PRODUCT_FEATURE_CLOUD_SENSORS_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_CLOUD_SENSORS,
  [Feature.PRODUCT_FEATURE_NETWORK_SENSORS]: Feature.PRODUCT_FEATURE_NETWORK_SENSORS,
  [Feature.PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE_DELEGATE]: Feature.PRODUCT_FEATURE_INTEGRITY_MONITOR_USABLE,
};

export const FeaturesForBundlesUsable: FeatureFlag[] = [
  FeatureFlag.PRODUCT_FEATURE_BUNDLE_MSP_SECURE_USABLE,
  FeatureFlag.PRODUCT_FEATURE_BUNDLE_MSP_SECURE_PLUS_USABLE,
  FeatureFlag.PRODUCT_FEATURE_BUNDLE_MSP_SECURE_EXTRA_USABLE,
  FeatureFlag.PRODUCT_FEATURE_A_LA_CARTE_USABLE,
];

export const FeaturesForBundlesDelegate: FeatureFlag[] = [
  FeatureFlag.PRODUCT_FEATURE_BUNDLE_MSP_SECURE_DELEGATE,
  FeatureFlag.PRODUCT_FEATURE_BUNDLE_MSP_SECURE_PLUS_DELEGATE,
  FeatureFlag.PRODUCT_FEATURE_BUNDLE_MSP_SECURE_EXTRA_DELEGATE,
  FeatureFlag.PRODUCT_FEATURE_A_LA_CARTE_DELEGATE,
];

export const FeaturesPartOfEdrDelegate: FeatureFlag[] = [
  FeatureFlag.PRODUCT_FEATURE_EDR_USABLE_DELEGATE,
  FeatureFlag.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE_DELEGATE,
  FeatureFlag.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE_DELEGATE,
];

export const FeaturesPartOfEdrUsable: FeatureFlag[] = [
  FeatureFlag.PRODUCT_FEATURE_EDR_USABLE,
  FeatureFlag.PRODUCT_FEATURE_SANDBOX_ANALYZER_USABLE,
  FeatureFlag.PRODUCT_FEATURE_ADVANCED_THREAT_PREVENTION_USABLE,
];

export const FeaturesPartOfXdrUsable: FeatureFlag[] = [
  FeatureFlag.PRODUCT_FEATURE_IDENTITY_SENSORS,
  FeatureFlag.PRODUCT_FEATURE_PRODUCTIVITY_SENSORS,
  FeatureFlag.PRODUCT_FEATURE_NETWORK_SENSORS,
  FeatureFlag.PRODUCT_FEATURE_CLOUD_SENSORS,
];

let FeatureUsableFlagToId: { [featureFlag: string]: Feature } | undefined;

export namespace Feature {
  export function getFeatureFlag(featureId: Feature): FeatureFlag {
    return FeatureIdToUsableMapping[featureId];
  }

  export function getFeatureId(featureFlag: string): Feature {
    if (FeatureUsableFlagToId === undefined) {
      FeatureUsableFlagToId = _.mapValues(
        _.invert(FeatureIdToUsableMapping),
        stringFeature => parseInt(stringFeature, 10) as Feature
      ) as { [featureFlag: string]: Feature };
    }

    return FeatureUsableFlagToId[featureFlag];
  }

  export function getFeatureUsableFromIdDelegate(featureDelegate: Feature): string {
    return FeatureIdToUsableMapping[FeatureIdDelegateToIdUsableMapping[featureDelegate]];
  }

  export function isFeatureAvailableForCompany(
    companyFeatures: { [featureId in Feature]: boolean },
    testFeature: Feature
  ) {
    if (!companyFeatures) {
      return false;
    }

    return companyFeatures[testFeature];
  }

  export function isAnyFeatureAvailableForCompany(
    companyFeatures: { [featureId in Feature]: boolean },
    testFeatures: Feature[]
  ) {
    if (!companyFeatures) {
      return false;
    }

    for (const testFeature of testFeatures) {
      if (companyFeatures[testFeature]) {
        return true;
      }
    }

    return false;
  }

  export function isAnyFeatureAvailable(availableFeatures: Feature[], testFeatures: Feature[]): boolean {
    for (const feature of testFeatures) {
      if (availableFeatures.includes(feature)) {
        return true;
      }
    }

    return false;
  }

  export function isFeatureAvailable(availableFeatures: Feature[], testFeature: Feature): boolean {
    return isAnyFeatureAvailable(availableFeatures, [testFeature]);
  }

  /**
   * Returns an object in which all flags in FeaturesForBundlesUsable are set to false, except for flags passed as a parameter which are set to true.
   *
   * @param {Partial<Record<FeatureFlag, boolean>>} features - An object containing flags to be set to true.
   * @returns {Partial<Record<FeatureFlag, boolean>>} - An object with flags set to false, except for flags passed as a parameter which are set to true.
   */
  export function getUpdatedUsableBundlesFeatures(
    features: Partial<Record<FeatureFlag, boolean>>
  ): Partial<Record<FeatureFlag, boolean>> {
    const updatedFeatures: Partial<Record<FeatureFlag, boolean>> = {};

    // Set all flags in FeaturesForBundlesUsable to false
    FeaturesForBundlesUsable.forEach(feature => {
      updatedFeatures[feature] = false;
    });

    // Set flags passed as a parameter to true
    for (const feature in features) {
      if (features[feature]) {
        updatedFeatures[feature as FeatureFlag] = true;
      }
    }

    return updatedFeatures;
  }

  /**
   * Returns the first feature set to 'true' in the 'companyFeatures' object that is included in the 'usableFeaturesList'.
   * If no feature is set to 'true', 'PRODUCT_FEATURE_A_LA_CARTE_USABLE' will be returned.
   * @param companyFeatures
   */
  export function getUsableBundleFeature(companyFeatures: any): FeatureFlag {
    const usableFeatures = FeaturesForBundlesUsable.filter(featureFlag => companyFeatures[featureFlag]);
    return usableFeatures[0] || FeatureFlag.PRODUCT_FEATURE_A_LA_CARTE_USABLE;
  }

  /**
   * Returns an object all the FeaturesForBundlesDelegate from companyFeatures
   * @param companyFeatures
   */
  export function getResellBundleFeatures(companyFeatures: any): any {
    const filteredObject = {};
    FeaturesForBundlesDelegate.forEach(key => {
      if (key in companyFeatures) {
        filteredObject[key] = companyFeatures[key];
      }
    });

    return filteredObject;
  }
}
